import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { t } from 'i18next';

import Logo from '~images/logo_primary.svg?react';

interface HydrationErrorFallbackProps {
  onRetry: () => void;
}

export default function HydrationErrorFallback({ onRetry }: HydrationErrorFallbackProps) {
  return (
    <>
      <Box
        sx={(theme) => ({
          position: 'absolute',
          top: 0,
          width: '100%',
          height: '100%',
          backgroundColor:
            theme.palette.mode === 'dark'
              ? 'rgba(10, 24, 32, .5)'
              : 'rgba(255, 255, 255, .5)',
          zIndex: 10,
        })}
      />
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          width: '100%',
          marginTop: 'calc(50vh - 120px)',
          textAlign: 'center',
          zIndex: 11,
          gap: 2,
        }}
      >
        <Logo width={189} height={37} />

        <Typography variant="body1" sx={{ mt: 3 }}>
          {t('error_messages.hydration_failed')}
        </Typography>

        <Button variant="contained" onClick={onRetry} sx={{ mt: 1 }}>
          {t('actions.retry')}
        </Button>
      </Box>
    </>
  );
}
